import {
  IActivityHistoryGroup,
  IActivityHistoryItemWithComponent,
  IActivityHistorySubGroup,
} from "../../domain/model";

export type ActivityHistoryEntry =
  | { type: "item"; date: Date; item: IActivityHistoryItemWithComponent }
  | { type: "subGroup"; date: Date; subGroup: IActivityHistorySubGroup };

export const mergeHistoryItemsAndSubgroups = (
  group: IActivityHistoryGroup,
): ActivityHistoryEntry[] => {
  // 1. Prepara los items sueltos
  const itemEntries: ActivityHistoryEntry[] = group?.items.map((item) => ({
    type: "item",
    date: new Date(item.date),
    item,
  }));

  // 2. Prepara los subGroups, usando la fecha del ítem más reciente de cada subgrupo
  const subGroupEntries: ActivityHistoryEntry[] = group?.subGroups.map((subGroup) => {
    // Asumimos que subGroup.items ya está ordenado de más reciente a más antiguo
    const mostRecent = subGroup?.items.length ? new Date(subGroup.items[0].date) : new Date(0);
    return {
      type: "subGroup",
      date: mostRecent,
      subGroup,
    };
  });

  // 3. Fusiona y ordena
  return [...itemEntries, ...subGroupEntries].sort((a, b) => b.date.getTime() - a.date.getTime());
};
